/* @flow */
import 'react-app-polyfill/ie11';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import 'react-select/dist/react-select.css';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';

import currentUser from './redux/current-user';
import App from './ui/App';
import { Store, persistor } from './redux';
import { API_URL } from './Constants';
import './styles/main.css';

const authLink = setContext((_, { headers }) => {
  let accessToken = currentUser.selectors.getCurrentUserAccessToken(Store.getState());
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: accessToken ? `Bearer ${accessToken}` : null,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(new HttpLink({ uri: `${API_URL}/graphql` })),
  cache: new InMemoryCache(),
});

(function init() {
  ReactDOM.render(
    <PersistGate persistor={persistor}>
      <Provider store={Store}>
        <BrowserRouter>
          <ApolloProvider client={client}>
            <App />
          </ApolloProvider>
        </BrowserRouter>
      </Provider>
    </PersistGate>,
    document.getElementById('root')
  );
})();



// WEBPACK FOOTER //
// ./src/index.js